<template>
  <div class="deck px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm">
    <CruiseDetailCommenTitle class="mb-[10px]" title="舱房信息" />
    <div>
      <el-tabs class="tabs" v-model="activeName">
        <el-tab-pane lazy :label="`${cabin.class_name}(${cabin.cabin.length})`" :name="cabin.class_name + ''" v-for="cabin in cabins"
          :key="cabin.class_name">
          <CruiseDetailCabinRoomThree :rooms="cabin.cabin" @tapImage="tapImage" type="cabin"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import DetailBlock from "@/views/company/CruiseDetailBlock.vue";
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
import CruiseDetailCabinRoomThree from "@/views/company/CruiseDetailCabinRoomThree.vue"

// import { Swiper, SwiperSlide } from "@/libs/swiper.js";

import { generateId } from "@/utils/helpers.js";
// import SrollbarWidth from "@/utils/scrollbar-width";
const cabinRoomTableColumns = [
  { label: "名称", prop: "name" },
  { label: "代码", prop: "code" },
  { label: "入住人数", prop: "numsText" },
  { label: "楼层", prop: "floorText" },
  { label: "面积", prop: "size" },
  { label: "窗型", prop: "window_style" }
];

const cabinRoomTableData = [
  {
    id: 1,
    name: "露台客房",
    code: "2V",
    nums: "1-4人",
    floor: "8，9，10层",
    size: "20m²",
    window_style: "有阳台"
  },
  {
    id: 2,
    name: "豪华露台客房",
    code: "J3",
    nums: "1-4人",
    floor: "8，9，10层",
    size: "22-28m² ",
    window_style: "有阳台"
  },
  {
    id: 3,
    name: "露台客房",
    code: "4V",
    nums: "1-4人",
    floor: "8，9，10层",
    size: "30m²",
    window_style: "有阳台"
  }
];

const roomList = [
  { title: "内舱房 Interior", name: "Interior" },
  { title: "海景房 Ocean View", name: "OceanView" },
  { title: "阳台房 Balcony", name: "Balcony" },
  { title: "套房 Suite", name: "Suite" }
];

class Room {
  constructor(props) {
    Object.assign(
      this,
      {
        id: generateId(),
        name: "",
        code: "", //代码
        min_people: 0,
        max_people: 0,
        floor: [],
        area: "0", //面积
        window_type_label: "", //窗型
        balcony_area: " ", //阳台面积
        introduction: "", //介绍
        images: []
      },
      props
    );
  }

  get floorText() {
    return this.floor.join(",") + "层";
  }

  get numsText() {
    return `${this.min_people}-${this.max_people}人`;
  }

  get size() {
    return `${this.area}m²`;
  }

  get window_style() {
    return this.window_type_label;
  }
}

export default {
  name: "CruiseDetailCabin",
  components: {
    DetailBlock,
    CruiseDetailCommenTitle,
    CruiseDetailCabinRoomThree,
    // VCollapse,
    // VCollapseItem,
    // Swiper,
    // SwiperSlide
  },
  props: {
    cabins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeName: this.cabins.length ? this.cabins[0].class_name : '',
      cabinRoomTableColumns: Object.freeze(cabinRoomTableColumns),
      cabinRoomTableData: Object.freeze(cabinRoomTableData),
      activeCabin: 0,
      roomList: Object.freeze(roomList),
      swiperOptions: {
        lazy: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },

      selectedRoom: new Room({}),
      cabinsKey: generateId()
    };
  },
  computed: {
    totalCabin() {
      return this.cabins.reduce((acc, curr) => acc + curr.num, 0)
    },
    // scrollbarWidth() {
    //   return SrollbarWidth();
    // },
    // formatedCabins() {
    //   return this.cabins.map(({ cabins, ...cabin }) => {
    //     let rooms = cabins.map(cabin => new Room(cabin));
    //     return {
    //       ...cabin,
    //       rooms
    //     };
    //   });
    // },
    // flatRooms() {
    //   return this.formatedCabins.reduce((result, cabin) => {
    //     return result.concat(cabin.rooms);
    //   }, []);
    // },
    // cabins3() {
    //   return this.cabins[1].cabins.slice()
    // }
  },
  watch: {
    // flatRooms: {
    //   handler(val) {
    //     if (val.length <= 0) return;
    //     this.selectedRoom = val[0];
    //   },
    //   immediate: true
    // },
    // cabins() {
    //   this.cabinsKey = generateId();
    // }
  },
  methods: {
    // handleClickRoom(room) {
    //   this.selectedRoom = room;
    // },
    // tabClick(event) {
    //   console.log(event)
    // }
    tapImage(imgPath) {
      // this.$refs.ImagePreviewView.setData('cabins', imgPath, );
      this.$emit('tapImage', imgPath);
    },
  }
};
</script>

<style lang="scss" scoped>

.tabs {
  ::v-deep {
    .el-tabs__content {
      overflow: visible;
    }
  }

  ::v-deep {
    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__item {
      font-size: 15px;
      font-weight: 500;
      padding: 0 10px;
    }
  }
}

</style>
